import { eventBus } from '@atc/cai-event-bus';
import { calculateDownPayment, getPersonalizedPaymentParams, getPersonalizedPaymentDetails, getLowestPersonalizedPayment } from '@atc/wallet-payment-fns';
import debugWallet from './debugWallet.js';
import { WALLET_GET_INVENTORY_PAYMENTS_COMPLETED } from '../constants/events.js';
function buildParams() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    pricingDetail: {
      salePrice,
      msrp
    } = {},
    listingType,
    type,
    partnerId,
    vin,
    specifications: {
      mileage: {
        value: mileage
      } = {}
    } = {},
    owner: {
      id: dealerId,
      zip: dealerZip
    } = {}
  } = data;
  const vehicleType = listingType || type || '';
  const isCertifiedUsed = ['certified', 'used'].includes(vehicleType.toLowerCase());

  // build params based on the requirements:
  // https://payment-calculator-swagger.s3.amazonaws.com/html2/index.html
  // https://ghe.coxautoinc.com/Autotrader/payment-calculation/blob/master/documentation/paymentCalc/request.txt
  return new URLSearchParams({
    dealerId,
    dealerZip,
    partnerId,
    listingType: vehicleType,
    certifiedUsed: isCertifiedUsed,
    salePrice,
    msrp,
    vin,
    defaultRate: true,
    mileage
  });
}
async function getInventoryPayments(_ref) {
  var _this = this;
  let {
    inventory = [],
    userZip
  } = _ref;
  const paymentsInfo = {
    ...this.paymentsInfo
  };
  const {
    tradeIn: {
      amountOwed = 0,
      value: tradeInValue = 0
    } = {},
    leaseTerm,
    leaseMileageRange,
    creditType,
    loanTerm
  } = paymentsInfo;
  const paymentDetails = await Promise.all(inventory.map(async function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      paymentServices: {
        paymentCalculationUrl
      } = {},
      pricingDetail: {
        salePrice,
        msrp
      } = {}
    } = data;
    const price = salePrice || msrp;
    const downPaymentValue = calculateDownPayment(price, paymentsInfo) || 0;
    const totalEquity = downPaymentValue + (tradeInValue - amountOwed);
    const zeroPayments = !price || totalEquity >= price;
    if (zeroPayments) {
      return {
        inventory: {
          ...data
        },
        payments: 0
      };
    }
    const personalizedPaymentsInfo = {
      ...paymentsInfo,
      leaseTerm,
      milesPerYear: leaseMileageRange,
      leaseDownPayment: downPaymentValue,
      includeCash: true
    };
    const paymentCalculationUrlParams = paymentCalculationUrl || buildParams(data).toString();
    const personalizedPaymentParams = getPersonalizedPaymentParams({
      paymentsInfo: personalizedPaymentsInfo,
      userZip
    });
    const response = {
      inventory: {
        ...data
      }
    };
    try {
      debugWallet('personalizedPaymentParams', personalizedPaymentParams);
      const paymentDetailsResponse = await getPersonalizedPaymentDetails({
        fetchPayments: _this.fetchers.PaymentCalculationFetcher.fetch.bind(_this.fetchers.PaymentCalculationFetcher),
        paymentCalculationUrl: paymentCalculationUrlParams,
        personalizedPaymentParams
      });
      if (Object.keys(paymentDetailsResponse?.details?.rates || {}).length > 0) {
        response.paymentDetails = await getLowestPersonalizedPayment(paymentDetailsResponse.details, creditType, loanTerm);
      }
    } catch (error) {
      response.error = error;
    }
    return response;
  }));
  debugWallet('payment details: ', this.paymentsInfo, paymentDetails);
  eventBus.emit(WALLET_GET_INVENTORY_PAYMENTS_COMPLETED, paymentDetails);
}
export { getInventoryPayments as default };
